import React, { useState } from "react";
import styled from "styled-components/macro";
import { PopUpItem } from "./PopUpItem";
import { Popup } from "semantic-ui-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle, faPlus } from "@fortawesome/free-solid-svg-icons";
import { RideUnitWrapper } from "./RideUnitWrapper";
import { DeleteUnit } from "./ride";
import ScaleComp from "../MyTulu/ScaleComp";

const RideUnit = ({
  ride,
  onPopupOpen,
  onPopupClose,
  itemsCount,
  popupItem,
  location,
  onRemovePress,
  onAddRidePress,
  unitIdx,
  type,
  rideItems,
  setRideItems,
  readOnly,
}) => {
  const getLimit = () => {
    if (type === "scooter") {
      return 4;
    }
    return 3;
  };

  const [onHover, setOnHover] = useState(-1);
  const uppertype = type.charAt(0).toUpperCase() + type.slice(1);
  const Items = ride.items;

  const size = Items.length;

  const isSmall =
    (size < 3 && type === "bicycle") || (size < 4 && type === "scooter");

  const _renderRideItems = () => {
    if (size === 0) {
      return (
        <EmptyWrapper>
          {!readOnly && (
            <FontAwesomeIcon
              className="add-icon"
              onClick={() => onAddRidePress(0, uppertype, unitIdx)}
              style={{
                filter: "drop-shadow(0px 0px 1px black)",
                position: "absolute",
                top: 300,
                bottom: 0,
                cursor: "pointer",
                margin: "auto 0",
                right: `${type === "scooter" ? -63 : -110}px`,
                zIndex: 100,
                padding: "10px",
              }}
              size={"3x"}
              color={"black"}
              icon={faPlus}
            />
          )}
        </EmptyWrapper>
      );
    }
    return Items.map((item, index) => {
      return (
        <Popup
          key={`${item.id}_${index}`}
          position="right center"
          on="click"
          onOpen={onPopupOpen}
          onClose={onPopupClose}
          trigger={
            <RideWrapper
              type={type}
              onMouseEnter={() => {
                setOnHover(index);
              }}
              onMouseLeave={() => setOnHover(-1)}
            >
              <Img src={item.unitImage} height={351} />
              {size > 1 && onRemovePress && !popupItem && onHover === index && (
                <FontAwesomeIcon
                  onClick={() => onRemovePress(index, unitIdx)}
                  style={{
                    filter: "drop-shadow(0px 0px 1px black)",
                    position: "absolute",
                    top: 0,
                    right: 0,
                    cursor: "pointer",
                    zIndex: 9999999999,
                    padding: "10px",
                  }}
                  size={"3x"}
                  color={"white"}
                  icon={faTimesCircle}
                />
              )}

              {size < getLimit() &&
                onAddRidePress &&
                !popupItem &&
                onHover === index && (
                  <FontAwesomeIcon
                    onClick={() => onAddRidePress(index, uppertype, unitIdx)}
                    style={{
                      filter: "drop-shadow(0px 0px 1px black)",
                      position: "absolute",
                      top: 0,
                      bottom: 0,
                      margin: "auto 0",
                      right: "-5px",
                      zIndex: 9999999999,
                      cursor: "pointer",
                      padding: "10px",
                    }}
                    size={"3x"}
                    color={"black"}
                    icon={faPlus}
                  />
                )}
            </RideWrapper>
          }
          flowing
        >
          <PopUpItem item={item} quantity={itemsCount[item.id]} />
        </Popup>
      );
    });
  };

  return (
    <Wrapper>
      <ScaleComp
        scaledPreDesktop={0.9}
        scaledLaptopM={0.65}
        scaledTablet={0.5}
        scaledMobile={0.18}
        isSmall={isSmall}
      >
        {!readOnly && (
          <DeleteUnit
            rideItems={rideItems}
            setRideItems={setRideItems}
            index={unitIdx}
          />
        )}
        <StandWrapper>
          <RideUnitWrapper size={size} type={type}>
            {_renderRideItems()}
          </RideUnitWrapper>
        </StandWrapper>
        {/* <RideUnitTopPlan size={size} location={location} type={type}/>
            <RideUnitFrontPlan size={size} location={location} type={type}/> */}
      </ScaleComp>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`;

/* const ScaleWrap = styled.div`
  transform-origin: top left;
  border: 1px solid red;
  @media ${device.mobileS} {
    transform: scale(0.3);
  }
  @media ${device.tablet} {
    transform: scale(0.6);
  }
`; */

const StandWrapper = styled.div`
  display: inline-block;
  position: relative;
`;

const Img = styled.img`
  object-fit: contain;
  z-index: 100;
  position: relative;
  cursor: pointer;
  padding-top: 10px;
`;

const RideWrapper = styled.div`
  display: inline-flex;
  position: relative;
  margin-left: ${(props) => (props.type === "scooter" ? 5.5 : 12)}px;
  margin-right: ${(props) => (props.type === "scooter" ? 6 : -45)}px;
`;

const EmptyWrapper = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  margin-left: 5.5px;
  margin-right: 6px;
`;

export { RideUnit };
